<div class="header -skeleton-header">
  <div class="-left-side">
    <div class="-logo-container">
      <a [routerLink]="'/'">
        <site-logo [type]="'global'"></site-logo>
      </a>
    </div>
    <div class="-main-nav-container">
      @for (item of [1, 2, 3]; track item) {
      <wp-skeleton class="-skeleton-pill" [loading]="true"></wp-skeleton>
      }
    </div>
  </div>
  <div class="-right-side">
    <div class="quick-links-container-lg-screen -skeleton-actions">
      <wp-skeleton class="-skeleton-search" [loading]="true"></wp-skeleton>
      @for (item of [1, 2, 3]; track item) {
      <wp-skeleton class="-skeleton-icon" [loading]="true"></wp-skeleton>
      }
      <wp-skeleton class="-skeleton-login" [loading]="true"></wp-skeleton>
    </div>
    <div class="-small-screen-hamburger-menu">
      <wp-skeleton class="-skeleton-icon" [loading]="true"></wp-skeleton>
    </div>
  </div>
</div>
